<template>
    <div v-if="userHasAccess">
        <div v-if="hasOldConfig && ! useNew">
          <div v-if="isAdmin" class="flex justify-center bg-gray-200 p-2">
            <button @click="useNew = true" class="btn-sm btn-green">Switch to new Config</button>
          </div>
          <admin-sponsors-old />
        </div>
        <admin-sponsors-new v-else/>
    </div>
    <div v-else>
      <no-access :section="'Sponsors'" :admin_email="adminData.show_admin.email"/>
    </div>
</template>

<script>
import AdminSponsorsNew from './AdminSponsors.vue'
import AdminSponsorsOld from '../../components/admin/Sponsors.vue'
import NoAccess from '@/views/admin/NoAccess.vue'
export default {
  components: {
    'admin-sponsors-new': AdminSponsorsNew,
    'admin-sponsors-old': AdminSponsorsOld,
    'no-access': NoAccess
  },
  data () {
    return {
      hasFetched: false,
      useNew: false,
      hasOld: false
    }
  },
  created () {
    this.fetchEventSponsorConfig()
  },
  methods: {
    fetchEventSponsorConfig () {
      this.axios.get(process.env.VUE_APP_ROOT_API + '/admin/eventSponsorConfigs', {headers: {'showman-event-id': this.eventId}})
        .then(response => {
          this.useNew = true
        }).catch(e => {
          // 404
        }).finally(() => {
          this.hasFetched = true
        })
    }
  },
  computed: {
    adminData () {
      return this.$store.state.admin.adminData
    },
    hasOldConfig () {
      const legacyConfig = this.$store.state.admin.adminData.event.sponsor_settings
      return legacyConfig && legacyConfig.types && legacyConfig.types.length > 0
    },
    currentUser () {
      return this.$store.state.user
    },
    userHasAccess () {
      let access = false
      let foundUser = false
      if (this.adminData.admin_id === this.currentUser.user_id || this.currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2') {
        access = true
      } else {
        this.adminData.event_user_access.forEach(ur => {
          if (ur.user_id === this.currentUser.user_id) {
            foundUser = true
            access = ur.sponsors_access
          }
        })
      }
      // If still no code set check if included in admin_id then assume it is a show series specialist and set to FULL for now.
      if (!foundUser) {
        if (this.adminData.admin_ids.includes(this.currentUser.user_id)) {
          access = true
        } else if (this.currentUser.role === 'ADMIN') {
          access = true
        }
      }
      return access
    },
    eventId () {
      return this.adminData.event.event_id
    },
    isAdmin () {
      if (this.currentUser.user_id === 'Clo1Va5v4pNuvE1TqHPNeKWFGay2' || this.currentUser.user_id === 'yJcDi4z2bffFtKq1jXI3deN8M9r1') {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
